import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SideMenu from "../../Components/SideMenu";
import { addSetting, getSettings, updateSetting } from "../../reducers/commonReducer";
import { home } from "../../const";
import SettingAction from "./SettingAction";
import BannerSliderManager from "./BannerSliderManager";

const customerBannerSettings = [
  {
    key: "customer_top_banner_text",
    name: "Customer Top Banner",
    filter: "customer_banner",
    halptext: "Image(s) shown above the customer chat list. Add more than one to show a slider.",
    buttonTitle: "Top Banner",
    valueType: "image",
    isSlider: true,
  },
  {
    key: "customer_marquee_text",
    name: "Customer Marquee Text",
    filter: "customer_banner",
    halptext: "Scrolling message shown under the top banner for customers.",
    buttonTitle: "Marquee",
    valueType: "text",
  },
  {
    key: "customer_bottom_banner_text",
    name: "Customer Bottom Banner",
    filter: "customer_banner",
    halptext: "Image shown near the bottom of the customer chat list.",
    buttonTitle: "Bottom Banner",
    valueType: "image",
  },
  {
    key: "customer_support_link",
    name: "Customer 24/7 Support Link",
    filter: "customer_banner",
    halptext: "Link opened when a customer taps the 24/7 support icon on the chat list.",
    buttonTitle: "Support Link",
    valueType: "text",
  },
];

const getCustomerBannerConfig = (settingKey) =>
  customerBannerSettings.find((item) => item.key === settingKey);

const Setting = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (localStorage.getItem("slug") !== "admin") {
      navigate(home, { replace: true });
      return;
    }
    dispatch(getSettings());
    if (!localStorage.getItem("x-auth-token")) {
      navigate(home);
    }
  }, [dispatch, navigate]);

  const { getSettingsData } = useSelector((state) => state.commonReducer);
  return (
    <>
      <SideMenu />
      <div className="mt-extra content container-fluid">
        <div className="m-3">
          <SettingAction api={addSetting} btnTitle={"Add"}/>
        </div>

        <div className="m-3 p-3 bg-light rounded border">
          <h5 className="mb-3">Customer Chat Banners</h5>
          <p className="text-muted mb-3">
            Only customers will see these. Branch leaders and team leaders are not connected to them.
          </p>
          <div className="d-flex flex-wrap gap-2">
            {customerBannerSettings.map((item) => {
              const existingSetting = getSettingsData?.list?.find(
                (setting) => setting?.key === item.key
              );

              const commonProps = {
                api: existingSetting ? updateSetting : addSetting,
                title: existingSetting
                  ? `Update ${item.buttonTitle}`
                  : `Add ${item.buttonTitle}`,
                btnTitle: item.buttonTitle,
                name: existingSetting?.name || item.name,
                halptext: existingSetting?.halptext || item.halptext,
                id: existingSetting?.id,
                filter: existingSetting?.filter || item.filter,
                settingKey: existingSetting?.key || item.key,
                status:
                  typeof existingSetting?.status === "boolean"
                    ? existingSetting.status
                    : true,
              };

              if (item.isSlider) {
                return (
                  <BannerSliderManager
                    key={item.key}
                    {...commonProps}
                    value={existingSetting?.value || ""}
                  />
                );
              }

              return (
                <SettingAction
                  key={item.key}
                  {...commonProps}
                  value={existingSetting?.value || ""}
                  linkUrl={existingSetting?.linkUrl || ""}
                  lockMeta={true}
                  valueLabel={item.buttonTitle}
                  valuePlaceholder={`Enter ${item.buttonTitle.toLowerCase()} text`}
                  valueRows={item.key === "customer_marquee_text" ? 4 : 3}
                  valueType={item.valueType}
                />
              );
            })}
          </div>
        </div>

        <table className="table table-scrolling ">
          <thead className="normalplace">
            <tr>
              <th className="over-col-size">Sr</th>
              <th className="over-col-size">Name</th>
              <th className="over-col-size">Value</th>
              <th className="over-col-size">HelpText</th>
              <th className="over-col-size">Filter</th>
              <th className="over-col-size">Status</th>
              <th className="over-col-size">Action</th>
            </tr>
          </thead>
          <tbody>
            {!!getSettingsData?.list &&
              getSettingsData?.list.map((data, index) => {
                const matchedBannerSetting = getCustomerBannerConfig(data?.key);

                return (
                  <React.Fragment key={index}>
                    <tr key={data?._id}>
                      <td>{index + 1}.</td>
                      <td>{data?.name}</td>
                      <td>{data?.value}</td>
                      <td>{data?.halptext}</td>
                      <td>{data?.filter}</td>
                      <td
                        className={
                          data?.status === true ? "text-success" : "text-danger"
                        }
                      >
                        <b>{data?.status === true ? "Active" : "InActive"}</b>
                      </td>
                      <td>
                        {/* <Button
                          className="m-1"
                          variant="danger"
                          onClick={async () => {
                            await dispatch(deleteSetting(data?.id));
                            dispatch(getSettings());
                          }}
                        >
                          <i className="bi bi-trash"></i>
                        </Button> */}
                        {matchedBannerSetting?.isSlider ? (
                          <BannerSliderManager
                            api={updateSetting}
                            title="Update Top Banner Slider"
                            name={data?.name}
                            value={data?.value}
                            halptext={data?.halptext}
                            id={data?.id}
                            filter={data?.filter}
                            settingKey={data?.key}
                            status={data?.status}
                          />
                        ) : (
                          <SettingAction
                            api={updateSetting}
                            title="Update Settings"
                            name={data?.name}
                            value={data?.value}
                            linkUrl={data?.linkUrl || ""}
                            halptext={data?.halptext}
                            id={data?.id}
                            filter={data?.filter}
                            settingKey={data?.key}
                            status={data?.status}
                            valueType={matchedBannerSetting?.valueType}
                            valueLabel={matchedBannerSetting?.buttonTitle}
                          />
                        )}
                      </td>
                    </tr>
                  </React.Fragment>
                );
              })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default Setting;
